import { Grid, TextField } from '@mui/material';

export default function FormPrecios(props) {
    const { style, size, almacenar, datoslista } = props;

    const handleKeyDown = (e) => {
        // Permitir números y la coma
        if (!(
            (e.key >= '0' && e.key <= '9') ||
            e.key === ',' ||
            e.key === 'Backspace' ||  // permitir borrar
            e.key === 'ArrowLeft' ||   // permitir mover cursor
            e.key === 'ArrowRight' ||
            e.key === 'Tab'             // permitir tabular
        )) {
            e.preventDefault();
        }
    }

    return (
        <>
            {datoslista &&
                <Grid
                    container
                    justifyContent="center"
                    alignItems="center"
                    spacing={2}
                    mt={1}
                    ml={1}
                    mr={1}
                >
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="precio_litro_sin_iva"
                            label="Precio litro sin IVA"
                            variant="outlined"
                            value={datoslista.precio_litro_sin_iva ?? ''}
                            onChange={almacenar}
                            onKeyDown={(e) => { handleKeyDown(e) }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="precio_litro_con_iva"
                            label="Precio litro con IVA"
                            variant="outlined"
                            value={datoslista.precio_litro_con_iva ?? ''}
                            onChange={almacenar}
                            onKeyDown={(e) => { handleKeyDown(e) }}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="precio_kilo_sin_iva"
                            label="Precio kilo sin IVA"
                            variant="outlined"
                            value={datoslista.precio_kilo_sin_iva ?? ''}
                            onChange={almacenar}
                            onKeyDown={(e) => { handleKeyDown(e) }}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            name="precio_kilo_con_iva"
                            label="Precio kilo con IVA"
                            variant="outlined"
                            value={datoslista.precio_kilo_con_iva ?? ''}
                            onChange={almacenar}
                            onKeyDown={(e) => { handleKeyDown(e) }}
                        />
                    </Grid>

                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            required
                            type="date"
                            name="vigencia"
                            label="Vigencia"
                            variant="outlined"
                            value={datoslista.vigencia}
                            onChange={almacenar}
                            onKeyDown={(e) => { handleKeyDown(e) }}
                        />
                    </Grid>
                    <Grid item xs={2}>
                        <TextField
                            fullWidth
                            size={size}
                            style={style}
                            focused
                            color="primary"
                            type="date"
                            name="fin_vigencia"
                            label="Fin Vigencia"
                            variant="outlined"
                            value={datoslista.fin_vigencia}
                            onChange={almacenar}
                        />
                    </Grid>
                </Grid>
            }
        </>

    )
}

//----- Component --------------------------------------------------------/
// Developer :  Candela Grosso
// Creation Date: 06/09/2024
// Version : 1
// Description : formulario para agregar precios, solo tngo los textfields y eso
//========================================================================/